import React, { useCallback, useState, useEffect, useRef } from "react";
import {
  Page,
  Card,
  Text,
  PageActions,
  TextField,
  FormLayout,
  Select,
  Toast,
} from "@shopify/polaris";
import axios from "../../../Assets/Lib/axios";
import { useNavigate } from "react-router-dom";
import TagsInput from "react-tagsinput";
import { MultiSelect } from "react-multi-select-component";

export const AddDeal = () => {
  const navigate = useNavigate();
  const [isSaving, setIsSaving] = useState(false);
  const [nameValue, setNameValue] = useState("");
  const handleChangeName = (newValue) => {
    setNameValue(newValue);
    setNameError("");
  };
  const [selectedType, setSelectedType] = useState("");
  const handleSelectChangeType = (newValue) => {
    setSelectedType(newValue);
    setTypeError("");
  };
  const optionsTypes = [
    { label: "Service", value: "1" },
    { label: "Product", value: "2" },
  ];
  const [typeError, setTypeError] = useState("");
  const [selectedSource, setSelectedSource] = useState("");
  const handleSelectChangeSource = (newValue) => {
    setSelectedSource(newValue);
  };
  const optionsSources = [
    { label: "Crm", value: "1" },
    { label: "Website", value: "2" },
    { label: "Campaign", value: "3" },
    { label: "Advertisment", value: "4" },
    { label: "Employee Referral", value: "5" },
    { label: "External Referral", value: "6" },
    { label: "Web Research", value: "7" },
    { label: "Partner", value: "8" },
    { label: "Public Relation", value: "9" },
    { label: "Cold Call", value: "10" },
  ];
  const [costValue, setCostValue] = useState("");
  const handleChangeCost = (newValue) => {
    setCostValue(newValue);
  };

  const [priceValue, setPriceValue] = useState("");
  const handleChangePrice = (newValue) => {
    setPriceValue(newValue);
  };
  const [purchasePriceValue, setPurchasePriceValue] = useState("");
  const handleChangePurchasePrice = (newValue) => {
    setPurchasePriceValue(newValue);
  };
  const [selectedReasonForLoss, setSelectedReasonForLoss] = useState("");
  const handleSelectChangeReasonForLoss = (newValue) => {
    setSelectedReasonForLoss(newValue);
  };
  const optionsReasonForLoss = [
    { label: "Expectation mismatch", value: "1" },
    { label: "Price", value: "2" },
    { label: "Unqualified", value: "3" },
    { label: "Customer", value: "4" },
    { label: "Lack of response", value: "5" },
    { label: "Missed follow-ups", value: "6" },
    { label: "Wrong target", value: "7" },
  ];
  const [noteValue, setNoteValue] = useState("");
  const handleChangeNote = (newValue) => {
    setNoteValue(newValue);
  };
  const [startDateValue, setStartDateValue] = useState("");
  const handleChangeStartDate = (newValue) => {
    setStartDateValue(newValue);
    setStartDateError("");
  };
  const [startDateError, setStartDateError] = useState("");
  const [expectedCloseDateValue, setExpectedCloseDateValue] = useState("");
  const handleChangeExpectedCloseDate = (newValue) => {
    setExpectedCloseDateValue(newValue);
    setExpectedCloseError("");
  };
  const [expectedCloseDateError, setExpectedCloseError] = useState("");
  const [actualCloseDateValue, setActualCloseDateValue] = useState("");
  const handleChangeActualCloseDate = (newValue) => {
    setActualCloseDateValue(newValue);
  };
  const [categories, setCategories] = useState([]);
  const [selectedCampaign, setSelectedCampaign] = useState("");
  const handleSelectChangeCampaign = (value) => {
    setSelectedCampaign(value);
  };
  const [statuses, setStatuses] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const handleSelectChangeStatus = (value) => {
    setSelectedStatus(value);
    setStatusError("");
  };
  const [statusError, setStatusError] = useState("");
  const [campaigns, setCampaigns] = useState([]);
  const [selectedCampaigns, setSelectedCampaigns] = useState([]);

  const [companies, setCompanies] = useState([]);
  const [stages, setStages] = useState([]);
  const [selectedStage, setSelectedStage] = useState("");
  const handleSelectChangeStage = (value) => {
    setSelectedStage(value);
    setStageError("");
  };
  const [stageError, setStageError] = useState("");

  const [contacts, setContacts] = useState([]);
  const [selectedContact, setSelectedContact] = useState("");
  const handleSelectChangeContact = (value) => {
    setSelectedContact(value);
    setContactError("");
  };
  const [contactError, setContactError] = useState("");
  const [admins, setAdmins] = useState([]);
  const [selectedAdmin, setSelectedAdmin] = useState("");
  const handleSelectChangeAdmin = (value) => {
    setSelectedAdmin(value);
  };
  const [nameError, setNameError] = useState("");

  useEffect(() => {
    fetchData();
  }, []);
  async function fetchData() {
    let responseStatuses = "";
    let responseCampaigns = "";
    let responseAdmins = "";
    let responseStages = "";
    let responseContacts = "";
    try {
      responseContacts = await axios.get(`/crm/contacts`);
      responseContacts?.data?.data?.data &&
        setContacts(
          responseContacts.data?.data?.data.map((item, index) => {
            return {
              label: item?.first_name + " " + item?.last_name,
              value: String(item.id),
              key: String(item.id),
            };
          })
        );
    } catch (error) {
      console.log(error);
    }
    try {
      responseCampaigns = await axios.get(`/crm/campaigns`);
      responseCampaigns?.data?.data?.data &&
        setCampaigns(
          responseCampaigns?.data?.data?.data.map((item, index) => {
            return {
              label: item.name,
              value: String(item.id),
              key: String(item.id),
            };
          })
        );
    } catch (error) {
      console.log(error);
    }

    try {
      responseStages = await axios.get(`/crm/deal-stages`);
      responseStages?.data?.data?.data &&
        setStages(
          responseStages.data?.data?.data.map((item, index) => {
            return {
              label: item.name,
              value: String(item.id),
              key: String(item.id),
            };
          })
        );
    } catch (error) {
      console.log(error);
    }
    try {
      responseAdmins = await axios.get(`/management/users`);
      responseAdmins?.data?.data?.data &&
        setAdmins(
          responseAdmins?.data?.data?.data.map((item, index) => {
            return {
              label: item?.first_name
                ? item?.first_name
                : "" + item?.last_name
                ? item?.last_name
                : "",
              value: String(item.id),
              key: String(item.id),
            };
          })
        );
    } catch (error) {
      console.log(error);
    }
  }
  const [active, setActive] = useState(false);
  const [toastContent, setToastContent] = useState("");
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  return (
    <Page
      title="Add Deal"
      narrowWidth
      backAction={{ onAction: () => navigate(`/admin/crm/deals`) }}
    >
      <Card sectioned>
        <FormLayout>
          <FormLayout.Group>
            <TextField
              label="Name"
              value={nameValue}
              onChange={handleChangeName}
              error={nameError}
            />
            <TextField
              label="Purchase Price"
              value={purchasePriceValue}
              onChange={handleChangePurchasePrice}
              type="number"
            />
          </FormLayout.Group>
          <FormLayout.Group>
            <TextField
              label="Cost"
              value={costValue}
              onChange={handleChangeCost}
              type="number"
            />
            <TextField
              label="Price"
              value={priceValue}
              onChange={handleChangePrice}
              type="number"
            />
          </FormLayout.Group>
          <FormLayout.Group>
            <Select
              label="Type"
              options={optionsTypes}
              onChange={handleSelectChangeType}
              value={selectedType}
              placeholder="Please select"
              error={typeError}
            />
            <Select
              label="Source"
              options={optionsSources}
              onChange={handleSelectChangeSource}
              value={selectedSource}
              placeholder="Please select"
            />
          </FormLayout.Group>
          <FormLayout.Group>
            <Select
              label="Reason for loss"
              options={optionsReasonForLoss}
              onChange={handleSelectChangeReasonForLoss}
              value={selectedReasonForLoss}
              placeholder="Please select"
            />
            <TextField
              label="Note"
              value={noteValue}
              onChange={handleChangeNote}
            />
          </FormLayout.Group>
          <FormLayout.Group>
            <TextField
              label="Start Date"
              value={startDateValue}
              onChange={handleChangeStartDate}
              type="date"
              error={startDateError}
            />
            <TextField
              label="Expected Close Date"
              value={expectedCloseDateValue}
              onChange={handleChangeExpectedCloseDate}
              type="date"
              error={expectedCloseDateError}
            />
          </FormLayout.Group>
          <TextField
            label="Actudal Close Date"
            value={actualCloseDateValue}
            onChange={handleChangeActualCloseDate}
            type="date"
          />
          <FormLayout.Group>
            <Select
              label="Campaign"
              options={campaigns}
              onChange={handleSelectChangeCampaign}
              value={selectedCampaign}
              placeholder="Please select a campaign"
            />
            <Select
              label="Admin"
              options={admins}
              onChange={handleSelectChangeAdmin}
              value={selectedAdmin}
              placeholder="Please select an admin"
              // error={companyError}
            />
          </FormLayout.Group>

          <FormLayout.Group>
            <Select
              label="Stage"
              options={stages}
              onChange={handleSelectChangeStage}
              value={selectedStage}
              placeholder="Please select a stage"
              error={stageError}
            />
            <Select
              label="Contact"
              options={contacts}
              onChange={handleSelectChangeContact}
              value={selectedContact}
              placeholder="Please select a contacts"
              error={contactError}
            />
          </FormLayout.Group>
        </FormLayout>
      </Card>
      <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
      />
      {toastMarkup}
    </Page>
  );
  function handleSave() {
    if (
      !nameValue ||
      selectedType === "" ||
      selectedContact === "" ||
      !startDateValue ||
      !expectedCloseDateValue ||
      selectedStage === ""
    ) {
      !nameValue && setNameError("This field is required");
      selectedType === "" && setTypeError("This field is required");
      selectedContact === "" && setContactError("This field is required");
      selectedType === "" && setTypeError("This field is required");
      !startDateValue && setStartDateError("This field is required");
      !expectedCloseDateValue &&
        setExpectedCloseError("This field is required");
      selectedStage === "" && setStageError("This field is required");
    } else {
      setIsSaving(true);
      const bodyObj = {
        name: nameValue,
        type: selectedType,
        cost: costValue,
        price: priceValue,
        purchase_price: purchasePriceValue,
        admin_id: selectedAdmin,
        contact_id: selectedContact,
        campaign_id: selectedCampaign,
        start_date: startDateValue,
        expected_close_date: expectedCloseDateValue,
        actual_close_date: actualCloseDateValue,
        source: selectedSource,
        stage_id: selectedStage,
        reason_for_loss: selectedReasonForLoss,
        notes: noteValue,
      };
      axios
        .post("/crm/deals", bodyObj)
        .then((res) => {
          setIsSaving(false);
          navigate("/admin/crm/deals");
        })
        .catch(function (error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response.data);
            console.log(error.response.status);
            console.log(error.response.headers);
            setToastContent(error.response.data.message);
            toggleActive();
            setIsSaving(false);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          console.log(error.config);
        });
    }
  }
};
